
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/azienda",
      function () {
        return require("private-next-pages/azienda.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/azienda"])
      });
    }
  